module.exports = __webpack_public_path__ + "img/rich-checked-ar.823d3516.png";